import { onboarding } from '@services';

interface ICreateAdminMessage {
  fileId: string;
  studioId: string;
  groupId: string;
  threadId: string;
  text: string;
}

const createAdminMessage = async (data: ICreateAdminMessage): Promise<void> => {
  await onboarding.post(`/api/v1/chat/admin/text`, data);
};

export { createAdminMessage };
